<template>
  <v-dialog v-model="dialog" width="1200">
    <v-card class="pb-5">
      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title> Resumo Básico </v-toolbar-title>
      </v-toolbar>
      <v-data-table :headers="headers" :items="resumoBasico" hide-default-footer />
    </v-card>
  </v-dialog>
</template>

<script>
import RelatorioService from '@/services/atualizacao/relatorio'

export default {
  name: 'DialogDeResumoBasico',

  props: ['showDialogResumoBasico', 'atualizacaoParam'],

  data: () => ({
    dialog: false,
    headers: [
      { text: 'E/S', value: 'entradaSaida' },
      { text: 'R$', value: 'totalValores' },
      { text: 'Registros', value: 'totalRegistros' },
      { text: 'Vinculados', value: 'totalVinculados' },
      { text: 'Com ICMS', value: 'totalComIcms' },
      { text: 'Com PC', value: 'totalComPisCofins' },
      { text: 'Com XML', value: 'totalComXml' },
      { text: 'Itens', value: 'totalItens' }
    ],
    resumoBasico: []
  }),

  watch: {
    showDialogResumoBasico() {
      return this.showDialogResumoBasico ? (this.dialog = this.showDialogResumoBasico) : ''
    },
    dialog() {
      return this.dialog ? this.initialize() : this.fecharDialog()
    }
  },

  methods: {
    async initialize() {
      this.dialog = true
      this.resumoBasico = []
      const extrato = await RelatorioService.buscarResumoBasico(this.atualizacaoParam.id)

      const entrada = {
        entradaSaida: 'E',
        totalValores: extrato.valorItensTotalEntrada.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }),
        totalRegistros: extrato.quantidadeItensTotalEntrada.toLocaleString('pt-BR'),
        totalVinculados: extrato.quantidadeItensExistentesEntrada.toLocaleString('pt-BR'),
        totalComIcms: extrato.quantidadeItensComIcmsEntrada.toLocaleString('pt-BR'),
        totalComPisCofins: extrato.quantidadeItensComPisCofinsEntrada.toLocaleString('pt-BR'),
        totalComXml: extrato.quantidadeItensComXmlEntrada.toLocaleString('pt-BR'),
        totalItens: extrato.quantidadeItensDiferentesEntrada.toLocaleString('pt-BR')
      }

      this.resumoBasico.push(entrada)

      const saida = {
        entradaSaida: 'S',
        totalValores: extrato.valorItensTotalSaida.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }),
        totalRegistros: extrato.quantidadeItensTotalSaida.toLocaleString('pt-BR'),
        totalVinculados: extrato.quantidadeItensExistentesSaida.toLocaleString('pt-BR'),
        totalComIcms: extrato.quantidadeItensComIcmsSaida.toLocaleString('pt-BR'),
        totalComPisCofins: extrato.quantidadeItensComPisCofinsSaida.toLocaleString('pt-BR'),
        totalComXml: extrato.quantidadeItensComXmlSaida.toLocaleString('pt-BR'),
        totalItens: extrato.quantidadeItensDiferentesSaida.toLocaleString('pt-BR')
      }

      this.resumoBasico.push(saida)
    },

    fecharDialog() {
      this.$emit('update:showDialogResumoBasico', false)
    }
  }
}
</script>
